import { Component } from '@angular/core';
import { HeaderLatestComponent } from 'src/app/home/landing-root/header-latest/header-latest.component';
import { PeopleflowFooterComponent } from 'src/app/peopleflow-footer/peopleflow-footer.component';

@Component({
  selector: 'app-test-feature',
    imports: [HeaderLatestComponent, PeopleflowFooterComponent], 
  standalone: true,
  templateUrl: './test-feature.html',
  styleUrl: './test-feature.scss',
})
export class TestFeature {

}
